import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

UIkit.use(Icons)

window.$ = window.jQuery = require('jquery')
require('./plugins/jquery.customSelect.min.js')

window.Vaex = {}

/**
 *
 * @type {{init, setScroll}}
 */
Vaex.Main = (function () {
    let init = function () {
        _initCustomSelect()
        _pricesTable()
        _widgetLinks()
        _searchField()
        _responsiveIframes()
        _toggleForm()
        
        $('.preventdefault').click(function (e) {
            e.preventDefault()
        })
        
        $('#mobilemenu .menu-services a').click(function (e) {
            UIkit.offcanvas(document.getElementById('mm')).hide()
        })
    }
    
    /**
     * @private
     */
    var _toggleForm = function () {
        $('.trade-item .button').click(function (e) {
            $(this).find('.open').toggle()
            $(this).find('.close').toggle()
            $(this).next().toggle()
        })
    }
    
    /**
     * Turn all iframes into responsive iframes
     * @private
     */
    const _responsiveIframes = function () {
        var $iframes = $('iframe')
        $iframes.each(function () {
            $(this).data('ratio', this.height / this.width).removeAttr('width').removeAttr('height')
        })
        
        $(window).resize(function () {
            $iframes.each(function () {
                var width = $(this).parent().width()
                $(this).width(width).height(width * $(this).data('ratio'))
            })
        }).resize()
    }
    
    /**
     * Sharebuttons
     */
    var share = function () {
        let $trigger = $(document.getElementById('share'))
        $trigger.click(function (e) {
            e.preventDefault()
            $('.sharebuttons').toggleClass('show')
        })
    }
    
    /**
     * @private
     */
    var _searchField = function () {
        var $trigger = $(document.getElementById('search_trigger'))
        var $body = $('body')
        $trigger.click(function () {
            $body.toggleClass('search-active')
            if ($body.hasClass('search-active')) {
                $('.search-field').focus()
            }
        })
    }
    
    /**
     * Set links if set
     * @private
     */
    var _widgetLinks = function () {
        var w = $('div[data-link]')
        $.each(w, function () {
            var $$ = $(this),
                cl = $$.attr('class'),
                st = $$.attr('style'),
                html = $$.html(),
                url = $$.attr('data-link'),
                a = $('<a/>').attr('href', url).html(html).addClass(cl).attr('style', st)
            $$.replaceWith(a[0].outerHTML)
        })
    }
    
    var totals = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    /**
     * Varkensprijzen gemiddelden
     * @private
     */
    const _pricesTable = function () {
        var $table = $('.prices')
        $table.find('tr:odd').css('background-color', '#ccc')
        var i
        for (i = 0; i < ($table.data('count') + 1); i++) {
            var count = 0
            var divideBy = 0
            $.each($table.find('.add.col' + i), function () {
                var number = $(this).html()
                if ($.isNumeric(number)) {
                    count += parseFloat(number)
                    divideBy++
                }
            })
            $table.find('.gem.col' + i).html((count / divideBy).toFixed(2))
        }
    }
    
    /**
     * init CustomSelect
     * @private
     */
    let _initCustomSelect = function () {
        if ($.isFunction($.fn.customSelect)) {
            $('.cs-select, .select').customSelect()
        }
    }
    
    /**
     * Scroll
     */
    let setScroll = function (el) {
        $('a.specs-nav-handle').click(function (e) {
            e.preventDefault()
            $('.specs-nav-handle').removeClass('active')
            let
                $$ = $(this),
                $section = $(document.getElementById($$.data('section')))
            $$.addClass('active')
            
            $('html, body').animate({
                scrollTop: $section.offset().top - 200,
            }, 200)
        })
    }
    
    /**
     * Services
     */
    const services = function () {
        let hash = window.location.hash.substring(1)
        if (hash) {
            doTabs(hash)
        }
        
        function locationHashChanged () {
            let hash = window.location.hash.substring(1)
            doTabs(hash)
        }
        
        window.onhashchange = locationHashChanged
        
        function doTabs (hash) {
            let $container = $('.services-container, .services-container-image')
            $container.find('.tabs').find('li').removeClass('uk-active')
            $container.find('.tabs').find('li.' + hash).addClass('uk-active')
            
            $container.find('.service').find('div').removeClass('uk-active')
            $container.find('.service').find('div.' + hash).addClass('uk-active')
        }
        
        if ($(window).width() < 640) {
            $('.services-container-image .tabs li').click(function (e) {
                var $scrollTo = $('.services-container-image .service').offset().top
                
                $('html, body').animate({
                    scrollTop: $scrollTo,
                }, 200)
            })
        }
    }
    
    const home = function () {
        let userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('safari') !== -1 &&
            userAgent.indexOf('chrome') === -1) {
            let luik = $('.luik-container')
            let countElements = document.getElementById(
                'drieluik_container').childElementCount
            if (countElements === 3) {
                luik.css('width', '33%')
            } else {
                luik.css('width', '49.9%')
            }
        }
    }
    
    /**
     * Remove sticky footer element when end of page reached
     */
    const scrollSpy = function () {
        function isInViewport (element) {
            var rect = element.getBoundingClientRect()
            var html = document.documentElement
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth)
            )
        }
        
        window.onscroll = function () {
            if (isInViewport(document.getElementById('scrollSpy'))) {
                $(document.getElementById('toRemoveSticky')).addClass('rm_sticky')
            }
        }
    }
    
    const touchStock = function () {
        if ($(window).width() <= 800) {
            $('#stocklist').on('touchstart click', 'li a.stockitem', function (event) {
                /*if(event.type == "touchstart") {
                    // Handle touchstart event.
                } else if(event.type == "click") {
                    // Handle click event.
                }*/
                
                var link = $(this)
                if (link.hasClass('hover')) {
                    return true
                } else {
                    link.addClass('hover')
                    $('#stocklist > li > a.stockitem').not(this).removeClass('hover')
                    event.preventDefault()
                    return false
                }
            })
        }
    }
    
    const touchEmployee = function () {
        if ($(window).width() <= 800) {
            $('.employee-container').on('touchstart', '.employee', function (event) {
                var employee = $(this)
                if (employee.hasClass('hover')) {
                    return true
                } else {
                    employee.addClass('hover')
                    $('.employee-container .employee').not(this).removeClass('hover')
                    event.preventDefault()
                    return false
                }
            })
        }
    }
    
    const truckFavorite = function () {
        
        $('#stocklist').on('touchstart click', '.favorite', function (event) {
            event.preventDefault()
            
            var $favoriteId = $(this).toggleClass('active').data('id')
            
            $.ajax({
                type: 'POST',
                url: '/stock/addFavorite',
                data: {favoriteId: $favoriteId},
                dataType: 'json',
                success: function (data) {
                    var len = Object.keys(data).length
                    
                    if (len) { // change number only
                        if ($('#topmenu li:first').hasClass('bgr-white')) {
                            $('#topmenu li:first a').html(len)
                        } else { // append link to favorites with number
                            $('#topmenu').prepend('<li class="bgr-white"><a href="/?favorites=1" class="favorites">' + len + '</a></li>')
                        }
                    } else { // remove link to favorites
                        if ($('#topmenu li:first').hasClass('bgr-white')) {
                            $('#topmenu li:first').remove()
                        }
                    }
                },
            })
        })
    }
    
    const toggleAdvanced = function () {
        $('.toggle_advanced').click(function (e) {
            $('.advanced').slideToggle()
        })
    }
    
    const initSlider = function (id, min, max, step = 10, thousand = '.', prefix = '', suffix = '') {
        var handlesSlider = document.getElementById(id)
        var input_min = $(document.getElementById(id + '_min'))
        var input_max = $(document.getElementById(id + '_max'))
        var display_min = $(document.getElementById(id + '_min_val'))
        var display_max = $(document.getElementById(id + '_max_val'))
        
        noUiSlider.create(handlesSlider, {
            start: [min, max],
            connect: true,
            range: {
                'min': min,
                'max': max,
            },
            format: Format,
            step: step,
        })
        
        handlesSlider.noUiSlider.on('update', function (values, handle) {
            input_min.val(values[0])
            input_max.val(values[1])
            display_min.html(values[0])
            display_max.html(values[1])
        })
        
        if (input_min.data('value')) {
            slider.noUiSlider.set([input_min.data('value'), input_max.data('value')])
        }
    }
    
    const initSliderTellerstand = function (min, max) {
        var slider = document.getElementById('slider_tellerstand')
        var Format = wNumb({
            decimals: 0,
            thousand: '.',
        })
        
        noUiSlider.create(slider, {
            start: [0, 2000000],
            range: {
                'min': [min, 25000],
                '25%': [100000, 50000],
                '80%': [1000000, 100000],
                'max': [max],
            },
            format: Format,
        })
        
        var input_min = $(document.getElementById('tsmin'))
        var input_max = $(document.getElementById('tsmax'))
        var display_min = $(document.getElementById('slider_tellerstand_min_val'))
        var display_max = $(document.getElementById('slider_tellerstand_max_val'))
        slider.noUiSlider.on('update', function (values, handle) {
            display_min.html(values[0])
            display_max.html(values[1])
            
            values[0] = values[0].replace(new RegExp('\\.', 'g'), '')
            values[1] = values[1].replace(new RegExp('\\.', 'g'), '')
            
            if (values[0] != min) {
                input_min.val(values[0])
            } else {
                input_min.val(null)
            }
            if (values[1] != max) {
                input_max.val(values[1])
            } else {
                input_max.val(null)
            }
        })
        
        if (input_min.data('value') || input_max.data('value')) {
            slider.noUiSlider.set([input_min.data('value'), input_max.data('value')])
        }
    }
    
    const initSliderVermogen = function (min, max) {
        var slider = document.getElementById('slider_vermogen')
        var Format = wNumb({
            decimals: 0,
        })
        
        noUiSlider.create(slider, {
            start: [min, max],
            range: {
                'min': [min],
                'max': [max],
            },
            step: 50,
            format: Format,
        })
        
        var input_min = $(document.getElementById('vmmin'))
        var input_max = $(document.getElementById('vmmax'))
        var display_min = $(document.getElementById('slider_vermogen_min_val'))
        var display_max = $(document.getElementById('slider_vermogen_max_val'))
        slider.noUiSlider.on('update', function (values, handle) {
            display_min.html(Math.round(values[0]))
            display_max.html(Math.round(values[1]))
            
            if (values[0] != min) {
                input_min.val(Math.round(values[0]))
            } else {
                input_min.val(null)
            }
            if (values[1] != max) {
                input_max.val(Math.round(values[1]))
            } else {
                input_max.val(null)
            }
        })
        
        if (input_min.data('value') || input_max.data('value')) {
            slider.noUiSlider.set([input_min.data('value'), input_max.data('value')])
        }
    }
    
    const initSliderVerkoopprijs = function (min, max) {
        var slider = document.getElementById('slider_verkoopprijs_particulier')
        var Format = wNumb({
            decimals: 0,
            thousand: '.',
        })
        
        noUiSlider.create(slider, {
            start: [min, max],
            range: {
                'min': [min, 1000],
                '20%': [20000, 5000],
                '50%': [60000, 10000],
                'max': [max],
            },
            format: Format,
        })
        
        var input_min = $(document.getElementById('vpmin'))
        var input_max = $(document.getElementById('vpmax'))
        var display_min = $(document.getElementById('slider_verkoopprijs_particulier_min_val'))
        var display_max = $(document.getElementById('slider_verkoopprijs_particulier_max_val'))
        slider.noUiSlider.on('update', function (values, handle) {
            display_min.html(values[0])
            display_max.html(values[1])
            
            values[0] = values[0].replace(new RegExp('\\.', 'g'), '')
            values[1] = values[1].replace(new RegExp('\\.', 'g'), '')
            
            if (values[0] != min) {
                input_min.val(values[0])
            } else {
                input_min.val(null)
            }
            if (values[1] != max) {
                input_max.val(values[1])
            } else {
                input_max.val(null)
            }
        })
        
        if (input_min.data('value') || input_max.data('value')) {
            slider.noUiSlider.set([input_min.data('value'), input_max.data('value')])
        }
    }
    
    const initSliderBouwjaar = function (min, max) {
        var slider = document.getElementById('slider_bouwjaar')
        var Format = wNumb({
            decimals: 0,
        })
        
        noUiSlider.create(slider, {
            start: [min, max],
            range: {
                'min': [min, 10],
                '40%': [1990, 1],
                'max': [max],
            },
            step: 50,
            format: Format,
        })
        
        var input_min = $(document.getElementById('bjmin'))
        var input_max = $(document.getElementById('bjmax'))
        var display_min = $(document.getElementById('slider_bouwjaar_min_val'))
        var display_max = $(document.getElementById('slider_bouwjaar_max_val'))
        slider.noUiSlider.on('update', function (values, handle) {
            display_min.html(Math.round(values[0]))
            display_max.html(Math.round(values[1]))
            
            if (values[0] != min) {
                input_min.val(Math.round(values[0]))
            } else {
                input_min.val(null)
            }
            if (values[1] != max) {
                input_max.val(Math.round(values[1]))
            } else {
                input_max.val(null)
            }
        })
        
        if (input_min.data('value') || input_max.data('value')) {
            slider.noUiSlider.set([input_min.data('value'), input_max.data('value')])
        }
    }
    
    var posAlert = function () {
        $( window ).resize(function() {
            var posAlertIcon = $(document.getElementById('posAlert'))
            var menuItem = $('.menu-vraag-en-aanbod')
            var rightSide = (menuItem.position().left + menuItem.width()) - 10
            posAlertIcon.css('margin-left', rightSide + 'px').css('opacity', 1)
        }).resize()
    }
    
    /**
     * Set public methods
     */
    return {
        init,
        setScroll,
        share,
        services,
        home,
        scrollSpy,
        touchStock,
        touchEmployee,
        truckFavorite,
        toggleAdvanced,
        initSlider,
        initSliderTellerstand,
        initSliderVermogen,
        initSliderVerkoopprijs,
        initSliderBouwjaar,
        posAlert,
    }
})()

Vaex.Form = (function () {
    var init = function (opts) {
        for (var i in opts) {
            var $row = $('.kanvas-form-field-row-' + opts[i].cms_form_field_id)
            switch (opts[i].type) {
                case 'radiobut':
                case 'multiselect':
                    var sel = 'input[id^="cms_form_field_' + opts[i].ref_id +
                        '_"]'
                    break
                default:
                    var sel = document.getElementById('cms_form_field_' +
                        opts[i].ref_id)
            }
            if (opts[i].action === 'show') {
                _rowShow(sel, $row, opts[i])
            } else {
                _rowHide(sel, $row, opts[i])
            }
        }
    }
    var _getElVal = function (el, matchValue, matchCond) {
        switch (el.tagName.toUpperCase()) {
            case 'INPUT':
                switch (el.type) {
                    case 'radio':
                    //return $(el).closest('label').text();
                    case 'checkbox':
                        var retText = ''
                        $(el).closest('ul').find('input:checked').each(function () {
                            var text = $(this).closest('label').text()
                            if (matchCond === 'has') {
                                if (text.indexOf(matchValue) > -1) {
                                    retText = text
                                    return
                                }
                            } else if (text === matchValue) {
                                retText = text
                                return
                            }
                        })
                        return retText
                }
                break
            case 'SELECT':
                return $(el).find('option:selected').text()
        }
        return el.value
    }
    var _rowHide = function (sel, $row, o) {
        $(sel).change(function () {
            var value = _getElVal(this, o.value, o.cond)
            switch (o.cond) {
                case 'neq':
                    return (value != o.value) ? $row.hide() : $row.show()
                case 'gt':
                    return (value > o.value) ? $row.hide() : $row.show()
                case 'eq':
                    return (value == o.value) ? $row.hide() : $row.show()
                case 'lt':
                    return (value < o.value) ? $row.hide() : $row.show()
                case 'has':
                    return (value.indexOf(o.value) > -1)
                        ? $row.hide()
                        : $row.show()
            }
        }).change()
    }
    var _rowShow = function (sel, $row, o) {
        $row.hide()
        $(sel).change(function () {
            var value = _getElVal(this, o.value, o.cond)
            switch (o.cond) {
                case 'neq':
                    return (value != o.value) ? $row.show() : $row.hide()
                case 'gt':
                    return (value > o.value) ? $row.show() : $row.hide()
                case 'eq':
                    return (value == o.value) ? $row.show() : $row.hide()
                case 'lt':
                    return (value < o.value) ? $row.show() : $row.hide()
                case 'has':
                    return (value.indexOf(o.value) > -1)
                        ? $row.show()
                        : $row.hide()
            }
        }).change()
    }
    var addressField = function () {
        $('.form-address-zipcode, .form-address-number').change(function () {
            var $parent = $(this).parent()
            var zip = $parent.find('.form-address-zipcode').val().replace(/ /g, '')
            var num = $parent.find('.form-address-number').val().replace(/ /g, '')
            var $street = $parent.find('.form-address-street')
            var $city = $parent.find('.form-address-city')
            if (zip && num) {
                $.ajax({
                    type: 'POST',
//                    url: 'http://api.art4m.nl/lookup/'+zip+'/'+num,
                    url: '/afForm/zipcodeLookup?zip=' + zip + '&num=' + num,
                    dataType: 'json',
                    success: function (data) {
                        if (data && data.city) {
                            $street.val(data.street).attr('readonly', 'readonly')
                            $city.val(data.city).attr('readonly', 'readonly')
                        } else {
                            $street.val('').removeAttr('readonly')
                            $city.val('').removeAttr('readonly')
                            _streetAutocomplete($street)
                            _cityAutocomplete($city)
                        }
                    },
                })
            } else {
                $street.val('').attr('readonly', 'readonly')
                $city.val('').attr('readonly', 'readonly')
            }
        }).change()
    }
    var _cityAutocomplete = function ($el) {
        // $el.autocomplete('destroy');
        $el.autocomplete({
            source: '/afForm/cityAutocomplete',
            minLength: 2,
        })
    }
    var _streetAutocomplete = function ($el) {
        // $el.autocomplete('destroy');
        $el.autocomplete({
            source: '/afForm/streetAutocomplete',
            minLength: 2,
        })
    }
    var dateField = function () {
        $('.date-field').inputmask('d-m-y')
    }
    var numField = function () {
        $('.is_numeric').keydown(function (e) {
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                (e.keyCode === 65 && e.ctrlKey === true) ||
                (e.keyCode === 67 && e.ctrlKey === true) ||
                (e.keyCode === 88 && e.ctrlKey === true) ||
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                return
            }
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
                (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault()
            }
        })
    }
    
    /**
     * Toggle form
     */
    var toggleForm = function () {
        var
            buttonToggle = $('.button-toggle'),
            trigger = $(document.getElementById('stock_voertuig_inruilen')),
            body = $('body')
        
        trigger.change(function () {
            if (trigger.is(':checked')) {
                body.addClass('part2-btn')
            } else {
                body.removeClass('part2-btn')
            }
        }).change()
        
        buttonToggle.click(function () {
            body.toggleClass('show-part2')
        })
    }
    
    /**
     * File upload
     */
    var fileUpload = function () {
        var bar = document.getElementById('js-progressbar')
        UIkit.upload('.js-upload', {
            url: '/test',
            multiple: true,
            allow: '*.(jpg|jpeg|gif|png|pdf)',

            beforeSend: function () {
                console.log('beforeSend', arguments)
            },
            beforeAll: function () {
                console.log('beforeAll', arguments)
            },
            load: function () {
                console.log('load', arguments)
            },
            error: function () {
                console.log('error', arguments)
            },
            complete: function () {
                console.log('complete', arguments)
            },

            loadStart: function (e) {
                console.log('loadStart', arguments)

                bar.removeAttribute('hidden')
                bar.max = e.total
                bar.value = e.loaded
            },

            progress: function (e) {
                console.log('progress', arguments)

                bar.max = e.total
                bar.value = e.loaded
            },

            loadEnd: function (e) {
                console.log('loadEnd', arguments)

                bar.max = e.total
                bar.value = e.loaded
            },

            completeAll: function () {
                console.log('completeAll', arguments)

                setTimeout(function () {
                    bar.setAttribute('hidden', 'hidden')
                }, 1000)

                alert('Upload Completed')
            },

        })
        // UIkit.upload('.js-upload', {
        //     url: '/test',
        //     multiple: true,
        //     allow : '*.(jpg|jpeg|gif|png)'
        //     // stock_bijlages
        // });
    }

    let photoreport = function(main_id, thumbs_id) {
        const mainCarousel = new Carousel(document.querySelector("#" + main_id), {
            Dots: false,
        });

        // Thumbnails
        // const thumbCarousel = new Carousel(document.querySelector("#" + thumbs_id), {
        //     Sync: {
        //         target: mainCarousel,
        //         friction: 0.9,
        //     },
        //     Dots: false,
        //     Navigation: false,
        //     center: true,
        //     slidesPerPage: 1,
        //     infinite: false,
        // });

        // Customize Fancybox
        Fancybox.bind('[data-fancybox="' + main_id + '"]', {
            Carousel: {
                on: {
                    change: (that) => {
                        mainCarousel.slideTo(mainCarousel.findPageForSlide(that.page), {
                            friction: 0.9,
                        });
                    },
                },
            },
        });
    }

    return {
        init: init,
        addressField: addressField,
        dateField: dateField,
        numField: numField,
        toggleForm: toggleForm,
        fileUpload: fileUpload,
        photoreport: photoreport
    }
})()

$(document).ready(function () {
    Vaex.Main.init()
})
